export default {
  title: "{ WLog }",

  author: "Abhishek WL",
  description: "My blog site",

  // The number of posts to a page on the site index.
  indexPageSize: 10,
}
